import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { Location } from '@angular/common';
import { NavService } from '../../_services/_nav.service';
import { NivelesService } from '../../_services/niveles.service';
import { NivelRangoService } from '../../_services/nivel-rango.service';
import { NivelRango } from '../../_models/nivel-rango';
import { SelectItem } from 'primeng/api';
import { UsuariosService } from '../../_services/usuarios.service';
import { Usuario } from '../../_models/usuario';
import { Table } from 'primeng/table';

@Component( {
  selector: 'app-nivel-rango',
  templateUrl: 'niveles-rango-usuario.component.html'
} )

export class NivelesRangoUsuarioComponent implements OnInit {

  nivelesRangos: NivelRango[] = [];
  nivel: any;
  nombreNivel: string;
  idNivel: string;
  columnas: any[] = [];
  selectNivelRango: SelectItem[] = [];
  selectNivelRango2: SelectItem[] = [];
  indicadorAsigna = false;
  idNivelRango: string;
  idNivelRango2: string;
  submitted: boolean;
  selectAcciones: SelectItem[] = [];
  /**
   * accion desvincular por defecto
   */
  idAccion = 1;
  usuarios: Usuario[] = [];
  cargangoUsuarios = true;
  usuariosSeleccionados: any[] = [];
  busqueda: string;
  guardando = false;
  @ViewChild('dt') t: Table;
  vertabla = true;

  constructor( private route: ActivatedRoute,
               private nivelesServicio: NivelesService,
               private nivelRangoService: NivelRangoService,
               private usuarioService: UsuariosService,
               private navService: NavService,
               private location: Location ) {
  }

  ngOnInit(): void {

    this.columnas = [
      { field: 'nivelRango', header: this.navService.buscarMensaje( 'NIVELES.LBL_RANGO' ), sort: true },
      { field: 'nombre', header: this.navService.buscarMensaje( 'LBL_NOMBRE' ), sort: true },
      { field: 'numeroDocumento', header: this.navService.buscarMensaje( 'LBL_NUMERODOCUMENTO' ), sort: true },
      { field: 'usuarioSistema', header: this.navService.buscarMensaje( 'LBL_USUARIO' ), sort: true },
      { field: 'indicadorHabilitado', header: this.navService.buscarMensaje( 'LBL_HABILITADO' ), sort: false }
    ];
    /**
     * listado de acciones
     */
    this.selectAcciones.push( { label: 'Desvincular', value: 1 } );
    this.selectAcciones.push( { label: 'Reasignar', value: 2 } );

    this.route.params.subscribe( ( params: Params ) => {
      let idNivel = null;
      if ( (params[ 'id' ] !== '' && params[ 'id' ] !== null && params[ 'id' ] !== undefined) ) {
        idNivel = params[ 'id' ];
        this.nivelesServicio.obtener( idNivel ).subscribe( res => {
          this.nivel = res;
          this.nombreNivel = res.nombre;
          this.idNivel = res.idNivel;
        } );
        this.nivelRangoService.listadoNivelRangoByNivel( idNivel ).subscribe( res => {
          this.nivelesRangos = res;
          res.map( x => {
            this.selectNivelRango.push( { label: x.nombre + ' - ' + x.rangoMaximo, value: x.idNivelRango } );
            this.selectNivelRango2.push( { label: x.nombre + ' - ' + x.rangoMaximo, value: x.idNivelRango } );
          } );
        } );
        this.cargarListaUsuarios( idNivel );
      }
    } );

  }

  cargarListaUsuarios( idNivel: any ) {
    this.vertabla = false;
    this.usuarios = [];
    this.usuarioService.listaUsuariosByNivel( idNivel ).subscribe( data => {
      this.cargangoUsuarios = false;
      this.usuarios = data;
      this.vertabla = true;
    }, error1 => {
      this.cargangoUsuarios = false;
      this.usuarios = [];
      this.vertabla = true;
    } );
  }

  mostrarOcultarNivelRango() {
    this.idNivelRango2 = null;
  }

  aplicandoAcciones() {
    this.guardando = true;
    this.submitted = true;
    if ( (this.idNivelRango && this.idAccion === 1 && this.usuariosSeleccionados.length > 0) || (this.idNivelRango && this.idAccion === 2 && this.idNivelRango2 && this.usuariosSeleccionados.length > 0) ) {
      if ( this.idNivelRango2 !== this.idNivelRango ) {
        if ( this.idAccion === 1 ) {
          this.usuariosSeleccionados.map( x => {
            x.idNivelRango = null;
          } );
        } else if ( this.idAccion === 2 ) {
          this.usuariosSeleccionados.map( x => {
            x.idNivelRango = this.idNivelRango2;
          } );
        }
        this.usuarioService.bulk( this.usuariosSeleccionados ).subscribe( res => {
          this.guardando = false;
          this.idNivelRango = null;
          this.idNivelRango2 = null;
          this.submitted = false;
          this.navService.setMesage( 2 );
          this.cargarListaUsuarios( this.idNivel );
          this.usuariosSeleccionados = [];
        }, error1 => {
          this.navService.setMesage( 2 );
          this.guardando = false;
        } );
      } else {
        this.guardando = false;
        this.navService.setMesage( 0, { severity: 'error', summary: 'Error', detail: 'El rango a asignar es el que tiene actualmente' } );
      }
    } else {
      this.guardando = false;
      this.navService.setMesage( 0, { severity: 'error', summary: 'Error', detail: 'Debe seleccionar al menos un usuario' } );
    }
    this.guardando = false;
  }

  atras() {
    this.location.back();
  }

}
